<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Quotation</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.quotation_id"
              :suggestions="quotations"
              placeholder="Select Quotation"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Quotaton Date</label>
          <div class="col-sm-8">
            <my-datepicker
              :date.sync="form.quotation_date"
              placeholder="Enter Quotaton Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">PO Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.po_no"
              class="form-control"
              autocomplete="off"
              placeholder="PO Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">DO Number</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.do_no"
              class="form-control"
              autocomplete="off"
              placeholder="DO Number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Delivered In</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.delivered_in"
              class="form-control"
              autocomplete="off"
              placeholder="Delivered In"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Receipt Port</label>
          <div class="col-sm-8">
            <my-select
              disableFormControl="true"
              :selection.sync="form.receipt_port_id"
              :suggestions="receiptPorts"
              placeholder="Select Receipt Port"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Remarks</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.remarks"
              class="form-control"
              autocomplete="off"
              placeholder="Remarks"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Receiving Person</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.receiving_person_id"
              :suggestions="ReceivingPersons"
              placeholder="Select Receiving Person"
            ></my-select>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "PurchaseOrderFormWidget",
  props: ["form"],
  data() {
    return {
      quotations: [],
      ReceivingPersons: [],
      receiptPorts: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("purchase_orders/masters");
      masters = masters.data;
      masters.quotations.forEach((quotation) => {
        this.quotations.push({
          id: quotation.id,
          name: quotation.quotation_no,
        });
      });
    },
  },
};
</script>
